/*

This function will be used in cases where we need to write logic based on some breakpoint.
One of the usecases is, we need to hide left navigation in website if breakpoint is lg
By default, returns true if screen width is the same or less than the given breakpoint.

theme - theme object returned using useTheme hook of component library
breakpoint - There are various breakpoints supported by component library listed here https://github.com/oyorooms/hmsexp-oyoos-component-library/blob/main/lib/module/utils/createBreakpoints.js
width - Device width which needs to be compared. In website, in most of the cases, it will be window width.
inclusive - To check whether the width is equal to the specified breakpoint width.
*/

export const isWidthDown = (theme, breakpoint, width, inclusive = true) => {
  if (inclusive) {
    return width <= theme.breakpoints.values[breakpoint];
  }
  return width < theme.breakpoints.values[breakpoint];
  // return breakpointKeys.indexOf(width) < breakpointKeys.indexOf(breakpoint);
};

/*

This function will be used in cases where we need to write logic based on some breakpoint.
By default, returns true if screen width is the same or less than the given breakpoint.

theme - theme object returned using useTheme hook of component library
breakpoint - There are various breakpoints supported by component library listed here https://github.com/oyorooms/hmsexp-oyoos-component-library/blob/main/lib/module/utils/createBreakpoints.js
width - Device width which needs to be compared. In website, in most of the cases, it will be window width.
inclusive - To check whether the width is equal to the specified breakpoint width.
*/

export const isWidthUp = (theme, breakpoint, width, inclusive = true) => {
  if (inclusive) {
    return width >= theme.breakpoints.values[breakpoint];
  }
  return width > theme.breakpoints.values[breakpoint];
};
